import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-mob',
  templateUrl: './login-mob.component.html',
  styleUrls: ['./login-mob.component.css'],
})
export class LoginMobComponent implements OnInit, AfterViewInit {
  @Input() loginObjform: any;
  base64Image: boolean;
  @Input('base64Image')
  set setBase64Image(value: boolean) {
    this.base64Image = value;
  }
  @Output() loginFormVal = new EventEmitter();
  @Output() validateFormBtnClicked = new EventEmitter();
  @Output() reloadCaptchaImageClicked = new EventEmitter();
  @ViewChild('loginForm') loginForm: any;
  @Input() loading;

  hidePassword: boolean;
  constructor(private router: Router) {}

  ngOnInit() {}

  setRememberMe(e) {
    this.loginObjform.rememberMe = e;
  }

  ngAfterViewInit() {
    this.loginFormVal.emit(this.loginForm);
  }

  validateForm() {
    this.validateFormBtnClicked.emit();
  }

  reloadCaptchaImage() {
    this.reloadCaptchaImageClicked.emit();
  }

  resetPassword() {
    this.router.navigate(['/resetPassword']);
  }

  navigateToPrivacyPage() {
    window.open(window.location.origin + '/portal/privacy.html');
  }
}
